import styled from "styled-components";

const IconNote = styled.span`
  color: ${p => p.theme.color.warning};
  margin:0 5px;
`;

export default IconNote;
